import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';

export const StyleNode = styled.div<{ color?: string; active?: boolean }>`
  ${({ color }) =>
    color &&
    css`
      color: ${color} !important;
      font-weight: 700;
    `};
`;

interface Props {
  note?: number;
  notationSystem: NotationSystem;
  className?: string;
  children?: React.ReactNode;
}

export function RONote(props: Props) {
  const { note, notationSystem, children } = props;

  const noteValue =
    note !== undefined ? notationSystem.getNotationFromValue(note) : '';

  return (
    <StyleNode
      className={props.className}
      color={
        note !== undefined
          ? notationSystem.getNoteColorContrast(note)
          : undefined
      }
      data-testid={`Note ${noteValue}`}
    >
      {noteValue}
      {children}
    </StyleNode>
  );
}
